import { Control } from "react-hook-form";
import { FormTextarea } from "../../../../components/ui/Input/FormTextArea/FormTextarea";
import { Card, CardContent, CardHeader } from "../../../../components/ui/common/card";
import { Checkbox } from "../../../../components/ui/common/checkbox";
import { Label } from "../../../../components/ui/common/label";

interface AdditionalCardProps {
  control: Control<any>;
  isSupplierAsUser: boolean;
  onIsSupplierAsUserChange: (value: boolean) => void;
  /** Mirrors the legacy `SuppllierRegisterForm`'s `hideSupplierContent` prop — the mapping-tool's inline "new supplier" form hides this checkbox, the Ingredient module's and the Edit drawer show it. Defaults to shown. */
  showRegisterAsUserCheckbox?: boolean;
}

const EYEBROW_CLASS =
  "tw-text-[10px] tw-uppercase tw-tracking-wider tw-text-muted-foreground tw-font-medium";

/**
 * "Additional" card — Other Information textarea, then the "Register
 * supplier as user" checkbox last. Shared between the supplier Edit drawer
 * and the Ingredient register flow's inline "new supplier" form.
 */
const AdditionalCard = ({
  control,
  isSupplierAsUser,
  onIsSupplierAsUserChange,
  showRegisterAsUserCheckbox = true
}: AdditionalCardProps) => {
  return (
    <Card className="tw-gap-4 tw-p-5">
      <CardHeader className="tw-p-0">
        <span className={EYEBROW_CLASS}>Additional</span>
      </CardHeader>
      <CardContent className="tw-flex tw-flex-col tw-gap-4 tw-p-0">
        <FormTextarea
          control={control}
          name="supplier_other_info"
          label="Other Information"
          placeholder="Other Information"
          className="tw-min-h-[110px] tw-resize-y tw-text-sm"
          labelClassName="tw-text-xs"
        />

        {showRegisterAsUserCheckbox ? (
          <div className="tw-flex tw-items-center tw-gap-2.5 tw-pt-1">
            <Checkbox
              id="register-as-user"
              checked={isSupplierAsUser}
              onCheckedChange={checked => onIsSupplierAsUserChange(Boolean(checked))}
            />
            <Label htmlFor="register-as-user" className="tw-cursor-pointer tw-text-xs tw-font-normal">
              Register supplier as user
            </Label>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
};

export default AdditionalCard;
